import { Component } from '@angular/core';

@Component({
  templateUrl: './upload-migration.page.html',
})
/**
 * Upload Miration Page (_8^())
 */
export class UploadMigrationPage {}
